import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, ArrowLeft } from 'lucide-react';

export const HorizontalSlider = ({ children, isDarkMode, viewAllLink, viewAllText, isRTL }) => {
  const scrollRef = useRef(null);

  const hasItems = Array.isArray(children)
    ? children.flat().filter(Boolean).length > 0
    : Boolean(children);

  if (!hasItems) {
    return (
      <div className={`flex items-center justify-center py-8 rounded-xl border border-dashed ${isDarkMode ? 'border-white/15 text-gray-500' : 'border-gray-300 text-gray-400'}`} data-testid="slider-empty-state">
        <p className="text-sm">{isRTL ? 'لا توجد منتجات متاحة حالياً' : 'No items available at the moment'}</p>
      </div>
    );
  }
  
  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      let scrollValue;
      if (direction === 'forward') {
        scrollValue = isRTL ? -scrollAmount : scrollAmount;
      } else {
        scrollValue = isRTL ? scrollAmount : -scrollAmount;
      }
      scrollRef.current.scrollBy({
        left: scrollValue,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative group">
      {/* Back Arrow */}
      <button 
        onClick={() => scroll('backward')}
        data-testid="slider-arrow-back"
        className={`absolute start-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all shadow-lg opacity-0 group-hover:opacity-100 ${isDarkMode ? 'bg-black/60 hover:bg-black/80 text-white border border-white/20' : 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 shadow-md'}`}
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      
      {/* Scrollable Content */}
      <div 
        ref={scrollRef}
        className="flex gap-3 overflow-x-auto pt-1 pb-3 px-12 scroll-smooth"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {children}
      </div>
      
      {/* Forward Arrow */}
      <button 
        onClick={() => scroll('forward')}
        data-testid="slider-arrow-forward"
        className={`absolute end-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all shadow-lg opacity-0 group-hover:opacity-100 ${isDarkMode ? 'bg-black/60 hover:bg-black/80 text-white border border-white/20' : 'bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 shadow-md'}`}
      >
        <ChevronRight className="w-5 h-5" />
      </button>
    </div>
  );
};

export default HorizontalSlider;
